// Profile Questions for Stages 1, 2, and 3
// These questions help users prepare for each stage and also serve as references for AI Persona

export interface ProfileQuestion {
    id: string;
    category: 'about_ideal' | 'about_me' | 'about_love';
    stage: 1 | 2 | 3;
    text: string;
    placeholder?: string;
}

// Stage 1: Imagine (상상의 단계) - About Me
export const STAGE_1_QUESTIONS: ProfileQuestion[] = [
    {
        id: 'me_soul_food',
        category: 'about_me',
        stage: 1,
        text: '나만의 소울푸드는?',
        placeholder: '예: 엄마가 해주시는 김치찌개'
    },
    {
        id: 'me_healing_spot',
        category: 'about_me',
        stage: 1,
        text: '나만의 힐링 스팟은?',
        placeholder: '예: 한강 공원, 집 근처 카페'
    },
    {
        id: 'me_superpower',
        category: 'about_me',
        stage: 1,
        text: '내가 갖고 싶은 초능력은?',
        placeholder: '예: 순간이동, 시간 정지'
    },
    {
        id: 'me_colors',
        category: 'about_me',
        stage: 1,
        text: '나를 표현하는 색깔 3가지는?',
        placeholder: '예: 파란색, 노란색, 초록색'
    },
    {
        id: 'me_life_ost',
        category: 'about_me',
        stage: 1,
        text: '내 인생의 OST는?',
        placeholder: '예: 좋은 날 - 아이유'
    }
];

// Stage 2: Hear (청각의 단계) - About Love
export const STAGE_2_QUESTIONS: ProfileQuestion[] = [
    {
        id: 'love_definition',
        category: 'about_love',
        stage: 2,
        text: '나에게 사랑이란?',
        placeholder: '예: 서로를 있는 그대로 받아들이는 것'
    },
    {
        id: 'love_date_priority',
        category: 'about_love',
        stage: 2,
        text: '데이트에서 가장 중요한 건?',
        placeholder: '예: 편안한 분위기, 재미있는 대화'
    },
    {
        id: 'love_bucket_list',
        category: 'about_love',
        stage: 2,
        text: '연인과 하고 싶은 버킷리스트는?',
        placeholder: '예: 함께 여행, 스카이다이빙'
    },
    {
        id: 'love_style',
        category: 'about_love',
        stage: 2,
        text: '나의 연애 스타일은?',
        placeholder: '예: 적극적, 차분한, 로맨틱한'
    },
    {
        id: 'love_after_breakup',
        category: 'about_love',
        stage: 2,
        text: '이별 후 나는?',
        placeholder: '예: 혼자만의 시간을 가짐, 친구들과 시간을 보냄'
    }
];

// Stage 3: See (시각의 단계) - About Ideal Type
export const STAGE_3_QUESTIONS: ProfileQuestion[] = [
    {
        id: 'ideal_appearance',
        category: 'about_ideal',
        stage: 3,
        text: '외모에서 가장 중요한 건?',
        placeholder: '예: 따뜻한 미소, 건강한 체형, 단정한 스타일 등'
    },
    {
        id: 'ideal_personality',
        category: 'about_ideal',
        stage: 3,
        text: '이상형의 성격은?',
        placeholder: '예: 배려심 있고 유머러스한 사람'
    },
    {
        id: 'ideal_hobby',
        category: 'about_ideal',
        stage: 3,
        text: '함께하고 싶은 취미는?',
        placeholder: '예: 여행, 운동, 영화 감상 등'
    },
    {
        id: 'ideal_lifestyle',
        category: 'about_ideal',
        stage: 3,
        text: '이상형의 직업/라이프스타일은?',
        placeholder: '예: 열정적으로 일하되 균형을 아는 사람'
    },
    {
        id: 'ideal_dealbreaker',
        category: 'about_ideal',
        stage: 3,
        text: '나의 딜브레이커(Deal-breaker)는?',
        placeholder: '예: 거짓말, 무례한 태도, 담배 등'
    }
];

// All questions combined
export const ALL_QUESTIONS = [
    ...STAGE_1_QUESTIONS,
    ...STAGE_2_QUESTIONS,
    ...STAGE_3_QUESTIONS
];

// Helper function to get questions by stage
export function getQuestionsByStage(stage: 1 | 2 | 3): ProfileQuestion[] {
    // TODO: In the future, fetch from API
    if (stage === 1) return STAGE_1_QUESTIONS;
    if (stage === 2) return STAGE_2_QUESTIONS;
    if (stage === 3) return STAGE_3_QUESTIONS;
    return [];
}

// Helper function to get questions by category
export function getQuestionsByCategory(category: ProfileQuestion['category']): ProfileQuestion[] {
    // TODO: In the future, fetch from API
    return ALL_QUESTIONS.filter(q => q.category === category);
}

// Get stage name
export function getStageName(stage: 1 | 2 | 3): string {
    const names = {
        1: 'Imagine (상상의 단계)',
        2: 'Hear (청각의 단계)',
        3: 'See (시각의 단계)'
    };
    return names[stage];
}

// Get stage category
export function getStageCategory(stage: 1 | 2 | 3): ProfileQuestion['category'] {
    const categories = {
        1: 'about_me' as const,
        2: 'about_love' as const,
        3: 'about_ideal' as const
    };
    return categories[stage];
}
